<template>
<div>
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <i class="el-icon-lx-cascades"></i> {{$t('pages.monthlyPower.breadcrumb')}}
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>

    <div class="container">
        <div>
            <div class="handle-headleft">
                <el-button type="primary" icon="el-icon-printer" @click="printlist">{{$t('pages.monthlyPower.print')}}</el-button>
                <el-button type="success" icon="el-icon-takeaway-box" @click="exportlist">{{$t('pages.monthlyPower.export')}}</el-button>
                <span class="toptotalWeight">
                    {{$t('pages.monthlyPower.total')}}
                    <el-input v-model="totalWeight" class="handle-select" disabled></el-input>
                </span>
            </div>
            <div class="handle-headright">
                <el-date-picker v-model="query.monthrange" type="monthrange" align="right" unlink-panels :range-separator="$t('pages.monthlyPower.rangeSeparator')" :start-placeholder="$t('pages.monthlyPower.startMonth')" :end-placeholder="$t('pages.monthlyPower.endMonth')" :picker-options="pickerOptions"></el-date-picker>
                <el-select v-model="query.balanceId" :placeholder="$t('pages.monthlyPower.type')" class="handle-select mr10">
                    <el-option v-for="item in electricityTypeArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.monthlyPower.search')}}</el-button>
            </div>
        </div>

            <el-table :data="logRecords" border class="table" header-cell-class-name="table-header" :height="tableHeight">
                <el-table-column type="index" width="80" :label="$t('pages.monthlyPower.index')"></el-table-column>
                <el-table-column sortable prop="date" :label="$t('pages.monthlyPower.date')">
                <template slot-scope="scope">
                    <i class="el-icon-time"></i>
                    {{ scope.row.date | formateData }}
                </template>
            </el-table-column>
            <el-table-column prop="electricityTypeName" :label="$t('pages.monthlyPower.type')"></el-table-column>
            <el-table-column :label="$t('pages.monthlyPower.monthPower')">
                <template slot-scope="scope">
                    <el-button type="text" style="color:#606266;font-size: 15px;padding-top: 0px;padding-bottom: 8px;">{{scope.row.electricityMonth}}</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</div>
</template>

<script>
import {
    dateFormat,
    SortField,
    dateAdd
} from '../../utils/helper';
import print from 'print-js';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
import service from '../../utils/request';
export default {
    name: 'logRecord',
    data: function () {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
                },
                shortcuts: [{
                        text: '本月',
                        onClick(picker) {
                            picker.$emit('pick', [new Date(), new Date()]);
                        }
                    },
                    {
                        text: '今年至今',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date(new Date().getFullYear(), 0);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近六个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setMonth(start.getMonth() - 6);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            tableHeight: window.innerHeight * 0.75,
            totalWeight: '',
            frequencyArr: [],
            balanceArr: [],
            electricityTypeArr: [{
                    id: 0,
                    name: "全部",
                },
                {
                    id: 1,
                    name: "煤矿总关口",
                },
                {
                    id: 2,
                    name: "井下供电关口",
                },
                {
                    id: 3,
                    name: "主运输设备供电关口",
                },
            ],
            logRecords: [],
            multipleSelection: [],
            query: {
                monthrange: '',
                balanceId: 0,
                StartMonth: '',
                EndMonth: '',
            }
        };
    },
    filters: {
        formateData(time) {
            let date = new Date(time);
            return dateFormat.formatDate(date, 'yyyy年MM月');
        }
    },
    created() {
        const end = new Date();
        const start = new Date();
        this.query.monthrange = [start, end];
        this.getBalance();
        this.getData();
    },
    methods: {
        getData() {
            var search = {
                StartMonth: dateFormat.formatDate(this.query.monthrange[0], 'yyyy-MM'),
                EndMonth: dateFormat.formatDate(this.query.monthrange[1], 'yyyy-MM'),
                balanceId: this.query.balanceId
            };
            this.$zybhttp
                .post('ProdInquiry/MonthlyPowerData', search)
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.logRecords = d;
                        this.totalWeight = res.data.msg;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        getBalance() {
            this.$zybhttp
                .post('Balance/GetList', {
                    Field3: '1',
                    Field4: '3'
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.balanceArr = [{
                            id: 0,
                            name: '全部'
                        }].concat(d).sort(SortField('id', 'asc'));
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        formateData(time) {
            let date = new Date(time);
            return dateFormat.formatDate(date, 'yyyy年MM月');
        },
        printlist() {
            var newdata = JSON.parse(JSON.stringify(this.logRecords));
            // 进行格式处理的数据
            newdata.forEach((item, index, arr) => {
                item.index = index + 1;
                item.date = this.formateData(item.date); // 日期格式处理
            });
            // 打印方法
            print({
                printable: newdata,
                header: `<div style="display: flex;flex-direction: column;text-align: center">
                        <h3>${this.$t('pages.monthlyPower.printTitle')}</h3>
                    </div>`,
                properties: [{
                        field: 'index',
                        displayName: this.$t('pages.monthlyPower.index'),
                        columnSize: `8%`
                    },
                    {
                        field: 'date',
                        displayName: this.$t('pages.monthlyPower.date'),
                        columnSize: `20%`
                    },
                    {
                        field: 'electricityTypeName',
                        displayName: this.$t('pages.monthlyPower.type'),
                        columnSize: `20%`
                    },
                    {
                        field: 'electricityMonth',
                        displayName: this.$t('pages.monthlyPower.monthPower'),
                        columnSize: `10%`
                    },
                ],
                type: 'json',
                gridHeaderStyle: 'border: 1px solid #000;text-align:center;padding:6px;0px;',
                gridStyle: 'border: 1px solid #000;text-align:center;padding:5px;10px;'
            });
        },
        exportlist() {
            let date = new Date();
            let name = dateFormat.formatDate(date, 'yyyyMMddhhmm');
            var wb = XLSX.utils.table_to_book(document.querySelector('.table'));
            var wbout = XLSX.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            });
            try {
                FileSaver.saveAs(new Blob([wbout], {
                    type: 'application/octet-stream'
                }), this.$t('pages.monthlyPower.printTitle') + name + '.xlsx');
            } catch (e) {
                if (typeof console !== 'undefined') console.log(e, wbout);
            }
            return wbout;
        },
        indexMethod(index) {
            return index + 1;
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}

.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.toptotalWeight {
    float: right;
    margin-left: 30px;
}
</style>
